






































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import FormOffer from '@/views/Offers/OfferCreation/Steps/FormOffer/FormOffer.vue';

import { IOfferEdit } from '@/models/offer';

import eventBus from '@/utils/eventBus';
import { IOfferRecommendation } from '@/models/smart-business-signup';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    Typography,
    CloseModalIcon,
    FormOffer
  }
})
export default class EditOfferModal extends Vue {
  @Prop() offer!: IOfferEdit;
  @Prop() index!: number;
  @Prop() editOffer!: (payload: IOfferRecommendation) => void;

  submitLoading = false;

  get type() {
    return this.offer.specialType;
  }

  get smartBusinessSignupData() {
    return this.$store.getters['businessOnboarding/getSmartBusinessSignup'];
  }

  async handleSubmit() {
    eventBus.$emit('saveOffer');
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  setSmartDataOffer(payload: IOfferRecommendation) {
    this.editOffer(payload);
  }

  async onSubmit(formattedPayload: IOfferRecommendation) {
    this.setSmartDataOffer(formattedPayload);
    this.$notification('Changes saved successfully!', 'success');

    segmentIo.track('AI Sign Up | Saved Offer', {
      Offer: formattedPayload
    });

    this.onClose();
  }

  created() {
    segmentIo.modal('AI Sign Up | Edit Offer', {
      'Offer Type': this.offer.type,
      Offer: this.offer
    });
  }
}
